/* jshint ignore:start */
import Component from 'metal-component';
import Soy from 'metal-soy';

var templates;
goog.loadModule(function(exports) {
var soy = goog.require('soy');
var soydata = goog.require('soydata');
// This file was automatically generated from ClayCheckboxLabel.soy.
// Please don't edit this file by hand.

/**
 * @fileoverview Templates in namespace ClayCheckboxLabel.
 * @public
 */

goog.module('ClayCheckboxLabel.incrementaldom');

goog.require('goog.soy.data.SanitizedContent');
goog.require('soy.asserts');
var soyIdom = goog.require('soy.idom');


/**
 * @param {{
 *  label: (!goog.soy.data.SanitizedContent|function()|string)
 * }} opt_data
 * @param {Object<string, *>=} opt_ijData
 * @param {Object<string, *>=} opt_ijData_deprecated
 * @return {void}
 * @suppress {checkTypes}
 */
function $render(opt_data, opt_ijData, opt_ijData_deprecated) {
  opt_ijData = opt_ijData_deprecated || opt_ijData;
  /** @type {!goog.soy.data.SanitizedContent|function()|string} */
  var label = soy.asserts.assertType(goog.isFunction(opt_data.label) || (goog.isString(opt_data.label) || opt_data.label instanceof goog.soy.data.SanitizedContent), 'label', opt_data.label, '!goog.soy.data.SanitizedContent|function()|string');
  soyIdom.print(label);
}
exports.render = $render;
/**
 * @typedef {{
 *  label: (!goog.soy.data.SanitizedContent|function()|string)
 * }}
 */
$render.Params;
if (goog.DEBUG) {
  $render.soyTemplateName = 'ClayCheckboxLabel.render';
}

exports.render.params = ["label"];
exports.render.types = {"label":"string|html"};
templates = exports;
return exports;

});

class ClayCheckboxLabel extends Component {}
Soy.register(ClayCheckboxLabel, templates);
export { ClayCheckboxLabel, templates };
export default templates;
/* jshint ignore:end */
